export default __webpack_public_path__ + "static/media/1819 cutlery side.cac797cc.png";